import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./contact-us.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Reveal from "./Components/Reveal/Reveal";

const API_BASE = (process.env.REACT_APP_API_URL || "https://aok-website.onrender.com").replace(/\/$/, "");

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ type: null, message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (status.type) setStatus({ type: null, message: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus({ type: null, message: "" });

    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
          site: "ignite",
        }),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setStatus({
          type: "error",
          message: data.message || "Something went wrong. Please try again.",
        });
        return;
      }
      setStatus({ type: "success", message: "Thanks! We'll be in touch soon." });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus({
        type: "error",
        message: "Could not send message. Check your connection or try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-container">
      <Navbar />

      <main className="contact-main">
        <Reveal as="section" className="contact-hero">
          <h1>Contact Us</h1>
          <p className="contact-tagline">
            Have a question or want to work together? We’d love to hear from you.
          </p>
        </Reveal>

        <section className="contact-section">
          <div className="contact-grid">
            <Reveal as="form" className="contact-form" onSubmit={handleSubmit}>
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="How can we help?"
                rows={5}
                required
              />
              {status.message && (
                <p className={status.type === "success" ? "contact-status success" : "contact-status error"}>
                  {status.message}
                </p>
              )}
              <button type="submit" className="contact-submit" disabled={submitting}>
                {submitting ? "Sending…" : "Send message"}
              </button>
            </Reveal>

            <Reveal className="contact-info" delay={100}>
              <h3>Get in touch</h3>
              <p>
                Reach out for event enquiries, partnerships, or general questions.
              </p>
              <div className="contact-details">
                <p>
                  <i className="fas fa-envelope" aria-hidden="true"></i>
                  <a href="mailto:Info@ignitevents.ie">Info@ignitevents.ie</a>
                </p>
                <p>
                  <i className="fas fa-phone-alt" aria-hidden="true"></i>
                  <a href="tel:+353873831780">087 383 1780</a> (Alison)
                </p>
                <p>
                  <i className="fas fa-phone-alt" aria-hidden="true"></i>
                  <a href="tel:+353872867880">087 286 7880</a> (Willie)
                </p>
              </div>
              <Link to="/" className="contact-back">
                ← Back to home
              </Link>
            </Reveal>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
